/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  locale: 'gl',
  Pagination: {
    items_per_page: '/ páxina',
    jump_to: 'Ir a',
    jump_to_confirm: 'confirmar',
    page: '',
    prev_page: 'Páxina anterior',
    next_page: 'Páxina seguinte',
    prev_5: '5 páxinas previas',
    next_5: '5 páxinas seguintes',
    prev_3: '3 páxinas previas',
    next_3: '3 páxinas seguintes'
  },
  DatePicker: {
    lang: {
      placeholder: 'Escolla data',
      rangePlaceholder: ['Data inicial', 'Data final'],
      locale: 'gl_ES',
      today: 'Hoxe',
      now: 'Agora',
      backToToday: 'Voltar a hoxe',
      ok: 'Aceptar',
      clear: 'Limpar',
      month: 'Mes',
      year: 'Ano',
      timeSelect: 'Seleccionar hora',
      dateSelect: 'Seleccionar data',
      monthSelect: 'Elexir un mes',
      yearSelect: 'Elexir un año',
      decadeSelect: 'Elexir unha década',
      yearFormat: 'YYYY',
      dateFormat: 'D/M/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Mes anterior (PageUp)',
      nextMonth: 'Mes seguinte (PageDown)',
      previousYear: 'Ano anterior (Control + left)',
      nextYear: 'Ano seguinte (Control + right)',
      previousDecade: 'Década anterior',
      nextDecade: 'Década seguinte',
      previousCentury: 'Século anterior',
      nextCentury: 'Século seguinte'
    },
    timePickerLocale: {
      placeholder: 'Escolla hora'
    }
  },
  TimePicker: {
    placeholder: 'Escolla hora'
  },
  Calendar: {
    lang: {
      placeholder: 'Escolla data',
      rangePlaceholder: ['Data inicial', 'Data final'],
      locale: 'gl_ES',
      today: 'Hoxe',
      now: 'Agora',
      backToToday: 'Voltar a hoxe',
      ok: 'Aceptar',
      clear: 'Limpar',
      month: 'Mes',
      year: 'Ano',
      timeSelect: 'Seleccionar hora',
      dateSelect: 'Seleccionar data',
      monthSelect: 'Elexir un mes',
      yearSelect: 'Elexir un año',
      decadeSelect: 'Elexir unha década',
      yearFormat: 'YYYY',
      dateFormat: 'D/M/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Mes anterior (PageUp)',
      nextMonth: 'Mes seguinte (PageDown)',
      previousYear: 'Ano anterior (Control + left)',
      nextYear: 'Ano seguinte (Control + right)',
      previousDecade: 'Década anterior',
      nextDecade: 'Década seguinte',
      previousCentury: 'Século anterior',
      nextCentury: 'Século seguinte'
    },
    timePickerLocale: {
      placeholder: 'Escolla hora'
    }
  },
  global: {
    placeholder: 'Escolla'
  },
  Table: {
    filterTitle: 'Filtrar menú',
    filterConfirm: 'Aceptar',
    filterReset: 'Reiniciar',
    selectAll: 'Seleccionar todo',
    selectInvert: 'Invertir selección',
    sortTitle: 'Ordenar'
  },
  Modal: {
    okText: 'Aceptar',
    cancelText: 'Cancelar',
    justOkText: 'Aceptar'
  },
  Popconfirm: {
    okText: 'Aceptar',
    cancelText: 'Cancelar'
  },
  Transfer: {
    searchPlaceholder: 'Buscar aquí',
    itemUnit: 'elemento',
    itemsUnit: 'elementos'
  },
  Upload: {
    uploading: 'Subindo...',
    removeFile: 'Eliminar arquivo',
    uploadError: 'Error ao subir o arquivo',
    previewFile: 'Vista previa',
    downloadFile: 'Descargar arquivo'
  },
  Empty: {
    description: 'Non hai datos'
  },
  Icon: {
    icon: 'icona'
  },
  Text: {
    edit: 'editar',
    copy: 'copiar',
    copied: 'copiado',
    expand: 'expandir'
  },
  PageHeader: {
    back: 'voltar'
  }
};
